export default class ESigningFormApi {
    /**
     * @description Inline GET fetch — no shared Api dependency
     * @param {string} endpoint
     * @param {Object} [params]
     * @returns {Promise<{status: number, body: any}>}
     */
    static async fetchJson(endpoint, params) {
        const url = params ? `${endpoint}?${new URLSearchParams(params)}` : endpoint;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: { 'Content-type': 'application/json;charset=UTF-8' },
            });
            const data = await response.json();
            return { status: response.status, body: data };
        } catch {
            return { status: 0, body: null };
        }
    }

    /**
     * @description Inline POST fetch — no shared Api dependency
     * @param {string} endpoint
     * @param {Object} payload
     * @returns {Promise<{status: number, body: any}>}
     */
    static async postJson(endpoint, payload) {
        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await response.json();
            return { status: response.status, body: data };
        } catch {
            return { status: 0, body: null };
        }
    }
}